import { IGetState, TCardId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { uploadFiles } from '../effects/uploadFiles';
import { getDriveDocsByCardId } from 'app/store/model/driveDocs/selectors/getDriveDocsByCardId';
import { attachmentDroppedSegmentEvent, attachmentDroppedSourceSegmentEvent } from '../../../CardAttachmentsSectionHOC/effects/segmentEffects';
import { ERestDriveDocType } from '../../../../../../../../../types/rest/IRestDriveDoc';
import { IDriveDoc } from '../../../../../../../../../store/model/card/types/IDriveDoc';
import { commentUpdate } from '../../../../../../../base/components/Comments/store/reducers/actions/commentUpdate';

export const onDropFiles = (
    cardId: TCardId,
    files: File[],
    isPopup: boolean,
    onProgress: (percent: number) => void,
    isComments: boolean,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const docs = getDriveDocsByCardId(getState(), cardId);
        // если в карте ещё нет файлов, то шлём source куда закинули: сразу в cardPanel или сначала открыли попап
        if (docs && docs.length) {
            dispatch(attachmentDroppedSegmentEvent());
        } else {
            dispatch(attachmentDroppedSourceSegmentEvent(isPopup));
        }
        return dispatch(uploadFiles(cardId, files, onProgress, false, isComments ? ERestDriveDocType.COMMENT : ERestDriveDocType.CARD))
            .then((driveDocs: IDriveDoc[]) => {
                if (isComments) {
                    dispatch(commentUpdate({ droppedAttachmentIds: driveDocs.map(driveDoc => driveDoc.id) }));
                }
            });
    };
    return action;
};
